import { AppDispatch } from 'store';
import { dynamicSeriesSlice } from 'store/reducers/dynamicSeries';
import { IDynamicYear } from 'types/mainPage';

export const setDynamicSeries =
  (years: IDynamicYear[]) => (dispatch: AppDispatch) => {
    dispatch(dynamicSeriesSlice.actions.setDynamicYears(years));
  };

export const resetDynamicSeries = () => (dispatch: AppDispatch) => {
  dispatch(dynamicSeriesSlice.actions.resetDynamicYears());
};

export const toggleOpenDynamicSeriesAction = () => (dispatch: AppDispatch) => {
  dispatch(dynamicSeriesSlice.actions.toggleOpen());
};
